import { render, staticRenderFns } from "./GetTheCustomerLastFourWeeksStatisticsFrame.vue?vue&type=template&id=732052c8&scoped=true&"
import script from "./GetTheCustomerLastFourWeeksStatisticsFrame.vue?vue&type=script&lang=js&"
export * from "./GetTheCustomerLastFourWeeksStatisticsFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732052c8",
  null
  
)

export default component.exports